import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SolicitareRankComponent } from './solicitare-rank.component';
import { AddSolicitareRankComponent } from './add-solicitare-rank/add-solicitare-rank.component';
import { EditSolicitareRankComponent } from './edit-solicitare-rank/edit-solicitare-rank.component';


@NgModule({
  declarations: [SolicitareRankComponent, AddSolicitareRankComponent, EditSolicitareRankComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [SolicitareRankComponent],
})
export class SolicitareRankModule { }
